import { MutationCache, QueryCache, QueryClient } from '@tanstack/react-query'

import { ApiError, NetworkError } from '../../types/errors'
import { showGlobalError } from '../notifications/globalNotification'

function handleGlobalError(error: Error, skipFlag: boolean | undefined): void {
  if (skipFlag) {return}

  if (error instanceof NetworkError) {
    showGlobalError('Network error. Please check your connection.')
    return
  }
  if (error instanceof ApiError && error.status >= 500) {
    showGlobalError('Something went wrong. Please try again later.')
  }
}

export const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError(error, query) {
      handleGlobalError(error, query.meta?.skipGlobalErrorToast)
    },
  }),
  mutationCache: new MutationCache({
    onError(error, _variables, _context, mutation) {
      handleGlobalError(error, mutation.meta?.skipGlobalErrorToast)
    },
  }),
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      gcTime: 10 * 60 * 1000, // 10 minutes (formerly cacheTime)
      retry: 1,
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: 0,
    },
  },
})
